import HttpService from "./htttp.service";

class EntityElementsService {
  getEntityElements = async (query, cancelToken) => {
    const endpoint = "entity-elements";
    return await HttpService.get(endpoint, query, cancelToken);
  };

  createEntityElement = async (payload) => {
    const endpoint = "entity-elements";
    return await HttpService.post(endpoint, payload);
  };

  removeEntityElement = async (id) => {
    const endpoint = "entity-elements/" + id;
    return await HttpService.delete(endpoint, id);
  };

  updateEntityElement = async (id, payload) => {
    const endpoint = "entity-elements/" + id;
    return await HttpService.put(endpoint, payload);
  };
}

export default new EntityElementsService();
